import { useTranslation } from "react-i18next";

export function useTranslateCountryCode() {
  const { t } = useTranslation("countries");

  return {
    t: (countryCode: string): string => {
      let countryName = t(countryCode, {
        returnObjects: true,
      });

      if (Array.isArray(countryName)) {
        return countryName[0];
      }

      return countryName;
    },
  };
}
